/**
 * @generated SignedSource<<1b49c15283a9448c53d35bc96dc50e74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgendaDateSelectorControlFragment_facility$data = {
  readonly club: {
    readonly supportsPrivate: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
  } | null | undefined;
  readonly id: string;
  readonly memberBookingWindowDays: number | null | undefined;
  readonly publicBookingWindowDays: number | null | undefined;
  readonly " $fragmentType": "AgendaDateSelectorControlFragment_facility";
};
export type AgendaDateSelectorControlFragment_facility$key = {
  readonly " $data"?: AgendaDateSelectorControlFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgendaDateSelectorControlFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgendaDateSelectorControlFragment_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicBookingWindowDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberBookingWindowDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPrivate",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetClubStartOfWeekNumberPatron_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "068d0f06d02d2654ca0a589d546b1fe3";

export default node;
